import { render } from "./TechSkills.vue?vue&type=template&id=3c547240&scoped=true"
const script = {}

import "./TechSkills.vue?vue&type=style&index=0&id=3c547240&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c547240"]])

export default __exports__